import React, { useState } from 'react';

const LightningIcon = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

const CredentialsModal = ({ isOpen, onClose, config, onSave }) => {
  const [localConfig, setLocalConfig] = useState(config);
  
  if (!isOpen) return null;
  
  const handleChange = (key, val) => setLocalConfig(prev => ({ ...prev, [key]: val }));
  const handleSave = () => { onSave(localConfig); onClose(); };
  
  return (
    <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-md flex flex-col border border-gray-700">
        <div className="p-4 border-b border-gray-700 bg-gray-900 rounded-t-lg flex justify-between items-center">
          <div className="flex items-center gap-2">
            <LightningIcon className="w-5 h-5 text-yellow-400" />
            <h3 className="font-bold text-white">Edit Credentials</h3>
          </div>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-xl font-bold px-2">×</button>
        </div>
        
        <div className="p-4 space-y-3 max-h-[60vh] overflow-y-auto">
          {/* Session ID Toggle */}
          <div className="flex items-center justify-between mb-4 p-2 bg-gray-700 rounded border border-gray-600">
            <span className="text-sm font-medium text-gray-200">Use Session ID</span>
            <label className="relative inline-flex items-center cursor-pointer">
              <input 
                type="checkbox" 
                className="sr-only peer" 
                checked={localConfig.useSessionId || false} 
                onChange={e => handleChange('useSessionId', e.target.checked)} 
              />
              <div className="w-11 h-6 bg-gray-600 peer-focus:ring-4 peer-focus:ring-yellow-400/20 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-500"></div>
            </label>
          </div>
          
          {/* Conditional Auth Fields */}
          {localConfig.useSessionId ? (
            <div>
              <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Session ID</label>
              <input 
                className="w-full border border-gray-600 rounded p-2 text-sm bg-gray-700 text-white focus:border-yellow-400 focus:outline-none" 
                value={localConfig.sessionId || ''} 
                onChange={e => handleChange('sessionId', e.target.value)} 
                placeholder="Enter active session ID..." 
              />
            </div>
          ) : (
            <>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Company ID</label>
                <input 
                  className="w-full border border-gray-600 rounded p-2 text-sm bg-gray-700 text-white focus:border-yellow-400 focus:outline-none" 
                  value={localConfig.companyId} 
                  onChange={e => handleChange('companyId', e.target.value)} 
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase mb-1">User ID</label>
                <input 
                  className="w-full border border-gray-600 rounded p-2 text-sm bg-gray-700 text-white focus:border-yellow-400 focus:outline-none" 
                  value={localConfig.userId} 
                  onChange={e => handleChange('userId', e.target.value)} 
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase mb-1">User Password</label>
                <input 
                  type="password" 
                  className="w-full border border-gray-600 rounded p-2 text-sm bg-gray-700 text-white focus:border-yellow-400 focus:outline-none" 
                  value={localConfig.userPassword} 
                  onChange={e => handleChange('userPassword', e.target.value)} 
                />
              </div>
              <div>
                <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Location ID (Optional)</label>
                <input 
                  className="w-full border border-gray-600 rounded p-2 text-sm bg-gray-700 text-white focus:border-yellow-400 focus:outline-none" 
                  value={localConfig.locationId || ''} 
                  onChange={e => handleChange('locationId', e.target.value)} 
                  placeholder="e.g. TIMBGC" 
                />
              </div>
            </>
          )}
        </div>
        
        <div className="p-4 border-t border-gray-700 bg-gray-900 flex justify-end rounded-b-lg gap-2">
          <button onClick={onClose} className="px-4 py-2 text-gray-300 font-medium hover:bg-gray-700 rounded">Cancel</button>
          <button onClick={handleSave} className="px-5 py-2 bg-yellow-500 text-gray-900 rounded font-medium shadow-sm hover:bg-yellow-400">⚡ Save</button>
        </div>
      </div>
    </div>
  );
};

export default CredentialsModal;